
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDebitCardGrid extends Serenity.EntityGrid<PsDebitCardRow, any> {
        protected getColumnsKey() { return PsDebitCardColumns.columnsKey; }
        protected getDialogType() { return PsDebitCardDialog; }
        protected getIdProperty() { return PsDebitCardRow.idProperty; }
        protected getInsertPermission() { return PsDebitCardRow.insertPermission; }
        protected getLocalTextPrefix() { return PsDebitCardRow.localTextPrefix; }
        protected getService() { return PsDebitCardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            
            
            
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        // console.log((window.location.href='/uplaod/').toString())
                        window.location.href = '/';
                        return false;

                        
                    },
                }
            );            
            return buttons;
        }
    }
}